import { Button, Dialog, DialogContent } from "@material-ui/core";
import React, { useState } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useForm } from "../../../../hooks/useForm";
import { AREAS_FISICAS, STEPPER_RECLAMOS_FORM } from '../../../../utils/constants';
import { desSeleccionarEfector, setActiveStepReclamos } from '../../../../actions/reclamos/reclamosActions';
import { StepperIngresoReclamoEfector } from "./StepperIngresoReclamoEfector";

export const AddButtonReclamoEfector = (props) => {

    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const { dataEfector, handleSave, idArea, usuario } = props;

    const dataReclamo = {
      fechaCarga: moment().format(),
      fechaRecepcion: moment().format(),
      //nroBeneficiario: dataAfiliado?.carnet,
      //apeNom: dataAfiliado?.apellido_y_nombre,
      //fechaNacimiento: dataAfiliado?.fecha_nacimiento,
      //nroDoc: dataAfiliado?.nro_doc,
      //fechaAlta: dataAfiliado?.fecha_alta,
      idEfector: dataEfector.idEfectorFacturacion,
      nombreFantasia: dataEfector.nombreFantasia,
      idTipoEfector: dataEfector.idTipoEfector,
      email: "",
      telefono: "",
      celular: "",
      //seccional: dataAfiliado?.domiciliosAfiliados.id_seccional,
      idUsuarioCarga: idArea?.idUsuario,
      nombreUsuario: usuario?.userName,
      subDestino: 0,
      destino: AREAS_FISICAS.COMUNICACIONES,
      categoriaReclamo: "",
      descripcion: "",
      estado: 1,
      fechaFinalizacion: "",
      urgente: 0,
      tipoReclamo: 1,
      tipoOrigen: "",
      idArea: idArea?.idArea,
      //idAfiliado: dataAfiliado?.id_afiliado,
    };
    const [
      formValues,
      handleInputChange,
      resetForm,
      setearValor,
      setearValores,
      ,
      ,
      ,
      setearVariosValores,
    ] = useForm(dataReclamo);

    const handleClickOpen = () => {
      //Poner validacion por si el afiliado tiene un reclamo pendiente
      //validation();
      setOpen(true);
    };
  
    const handleClose = () => {
      resetForm();
      setOpen(false);
      dispatch(setActiveStepReclamos(STEPPER_RECLAMOS_FORM.RECLAMOS_INGRESO));
      dispatch(desSeleccionarEfector());
    };

  return (
    <React.Fragment>
       <Button variant={"contained"} color="primary" onClick={handleClickOpen}>
        Ingresar Caso
      </Button>
      {open && (
        <Dialog open={open} fullWidth maxWidth="md">
          <DialogContent>
            <StepperIngresoReclamoEfector
              formValues={formValues}
              handleInputChange={handleInputChange}
              setearValor={setearValor}
              handleSubmit={(data, stepperMenu) =>
                handleSave(data, stepperMenu)
              }
              setearValores={setearValores}
              setearVariosValores={setearVariosValores}
              resetForm={resetForm}
              handleCancel={handleClose}
              editable={true}
              dataEfector={dataEfector}
            />
          </DialogContent>
        </Dialog>
      )}
    </React.Fragment>
  )
}
